import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "DevTools" */ './lazyIndex'),
    { name: 'DevTools' }
);

export const lazySetupDevTracing: LazyAction<typeof lazyIndex.initializeTracer, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.initializeTracer);
